module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/395.9ebdc699.png";